"use client";

import React from "react";
import { Info, Clock } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const pricingOptions = [{
  duration: "30 minutes",
  price: "£45",
  description: "Targeted treatment focused on specific muscle groups or acute tension areas."
}, {
  duration: "60 minutes",
  price: "£70",
  description: "Comprehensive full-body or multi-area session for deep muscular recovery and maintenance."
}];
export default function MassagePricing() {
  return <section id="massagepricing" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 lg:py-24">
      <div className="container mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-foreground font-default">
            Sports & Recovery Massage in St Albans
          </h2>
          <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
            Dedicated massage appointments for muscular tension, recovery, general maintenance and active lifestyles.
          </p>
        </div>

        {/* Pricing Cards Grid */}
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:gap-8 max-w-4xl mx-auto">
          {pricingOptions.map((item, index) => <Card key={item.duration} data-index={index} className="relative flex flex-col justify-between border-border bg-card shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1 rounded-xl">
              <CardHeader className="pb-4">
                <div className="flex items-center justify-between gap-2">
                  <div className="flex items-center gap-2 text-primary">
                    <Clock className="size-4 shrink-0" aria-hidden="true" />
                    <CardTitle className="text-xl font-semibold text-card-foreground">
                      {item.duration}
                    </CardTitle>
                  </div>
                </div>
                <div className="mt-4 flex items-baseline gap-1">
                  <span className="text-4xl font-extrabold tracking-tight text-foreground">
                    {item.price}
                  </span>
                </div>
              </CardHeader>
              <CardContent className="pt-0">
                <CardDescription className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  {item.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>

        {/* Booking CTA Button */}
        <div className="mt-10 flex justify-center">
          <Button asChild size="lg" className="px-8 font-semibold shadow-sm transition-transform active:scale-[0.99]">
            <Link to="https://physiogenics.uk3.cliniko.com/bookings?business_id=1933385715966552600" newTab>
              Book Massage
            </Link>
          </Button>
        </div>

        {/* Advisory Alert Container */}
        <div className="mt-10 mx-auto max-w-3xl">
          <Alert className="border-border/80 bg-muted/50 text-card-foreground">
            <Info className="size-4 text-muted-foreground" aria-hidden="true" />
            <AlertDescription className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
              If you have a new injury or significant unexplained pain, physiotherapy may be the more appropriate starting point.
            </AlertDescription>
          </Alert>
        </div>
      </div>
    </section>;
}